import { render, staticRenderFns } from "./root.vue?vue&type=template&id=93c8363c&lang=pug&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"
import style0 from "./root.vue?vue&type=style&index=0&id=93c8363c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports